// extracted by mini-css-extract-plugin
export default {"wrapper":"FiltersWrapper_wrapper__5h8Rs"};